var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserAnda(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_18457",
    "data-name": "Rect\\xE1ngulo 18457",
    width: 58,
    height: 61.354,
    fill: "#e8112a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-anda",
    transform: "translate(-4585 1313)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_674",
    "data-name": "Elipse 674",
    cx: 54,
    cy: 54,
    r: 54,
    transform: "translate(4585 -1313)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4291",
    "data-name": "Grupo 4291",
    transform: "translate(4610 -1289)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4289",
    "data-name": "Grupo 4289",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3814",
    "data-name": "Trazado 3814",
    d: "M55.065,44.069c.361-13.263.052-29.21.052-29.21S55.013,1.338,34.267.15,2.48,4.686,1.805,20.743c12.076,0,17.643.161,17.643.161s-.677-7.064,6.425-8.205c6.077-.039,6.638,0,6.638,0s5.9.367,4.935,7.857c0,0-.039,2.032-4.935,2.98S2.889,23.445.309,39.924s11.87,20.5,11.87,20.5,16.205,4.129,26.114-5.058c.723,2.581,1.226,4.18,1.226,4.18H58s-3.3-2.219-2.935-15.483M39.008,39.785c-.258,4.129-4.748,10.167-13.418,9.289L21.2,52.584l.568-4.593A7.75,7.75,0,0,1,16.3,41.179c-.361-5.419,5.522-9.805,12.309-9.857s10.657,4.335,10.4,8.464",
    transform: "translate(0 0)",
    fill: "#e8112a"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAnda);
export default __webpack_public_path__ + "static/media/user-anda.32bffb06ec72e3fce02e6f731028f4a2.svg";
export { ForwardRef as ReactComponent };